import {get, post} from "./index";
import {applicationName} from "../utils";

//是否认证
export const getMicroblogData = (param, callBack) => {
    get("/cm-sites-" + applicationName()+`/media/isOAuth`, {time: new Date().getTime(),...param}, callBack)
}
//去验证
export const getGoProveData = (param, callBack) => {
    get("/cm-sites-" + applicationName()+`/media/gotoOAuth`, {time: new Date().getTime(),...param}, callBack)
}
//检查是否验证成功
export const getIfProveSuccessData = (param, callBack) => {
    post("/cm-sites-" + applicationName()+`/media/isOAuthSuccess`, {time: new Date().getTime(),...param}, callBack)
}